import {create} from 'zustand';
import {SubscriptionPlan} from '@/types/models/pricing/subscriptionPlan';

type ContentStudioPricingModalStateDefinition = {
  state: ModalState;
  source?: string;
  navigationContext?: 'direct_to_confirm' | 'via_upgrade';
  subscriptionChangePlans?: {
    currentSubscriptionId: string;
    currentPlan: SubscriptionPlan;
    selectedPlan: SubscriptionPlan;
  };
  onCancelCallback?: () => void;
  onSuccessCallback?: () => void;
};

export enum ModalState {
  CLOSED = 'closed',
  UPGRADE = 'upgrade',
  CHANGE_CONFIRM = 'change_confirm',
}

const contentStudioPricingModalStore =
  create<ContentStudioPricingModalStateDefinition>(() => ({
    state: ModalState.CLOSED,
    source: undefined,
    navigationContext: undefined,
    subscriptionChangePlans: undefined,
    onCancelCallback: undefined,
    onSuccessCallback: undefined,
  }));

const openUpgradeModal = ({
  source,
  onCancelCallback,
  onSuccessCallback,
}: {
  source?: string;
  onCancelCallback?: () => void;
  onSuccessCallback?: () => void;
}) => {
  contentStudioPricingModalStore.setState({
    state: ModalState.UPGRADE,
    source,
    navigationContext: undefined,
    onCancelCallback,
    onSuccessCallback,
  });
};

const openConfirmModal = ({
  source,
  plans,
  navigationContext,
}: {
  source?: string;
  plans?: {
    currentSubscriptionId: string;
    currentPlan: SubscriptionPlan;
    selectedPlan: SubscriptionPlan;
  };
  navigationContext?: 'direct_to_confirm' | 'via_upgrade';
}) => {
  contentStudioPricingModalStore.setState({
    state: ModalState.CHANGE_CONFIRM,
    source,
    navigationContext,
    subscriptionChangePlans: plans,
  });
};

const closeModal = () => {
  return contentStudioPricingModalStore.setState({
    state: ModalState.CLOSED,
    source: undefined,
    navigationContext: undefined,
    subscriptionChangePlans: undefined,
    onCancelCallback: undefined,
    onSuccessCallback: undefined,
  });
};

export const contentStudioPricingModalActions = {
  openUpgradeModal,
  openConfirmModal,
  closeModal,
};

export default contentStudioPricingModalStore;
